import React, {Component} from 'react';

const languageList = ['JavaScript', 'HTML', 'CSS', 'SASS', 'Node.js', 'jQuery', 'VB', 'React', 'Ruby', 'Rails', 'React Native', 'Unity', 'C#', 'Rust'];
const systemList = ['Git', 'MongoDB', 'MySql', 'PostgreSQL', 'Heroku', 'Trello', 'Jupyter', 'Binderhub', 'Dokku', 'Digital ocean', 'OpenAI', 'Devin Desktop'];
const otherList = ['Adaptable', 'Flexible', 'Problem Solving', 'Leadership', 'Teamwork']

export default class Skills extends Component {


  render() {
    let langs = languageList.map((skill) => {
      return (
        <div key={skill} className='skill-item'>
          {skill}
        </div>
      )
    })

    let systems = systemList.map((skill) => {
      return (
        <div key={skill} className='skill-item'>
          {skill}
        </div>
      )
    })

    let others = otherList.map((skill) => {
      return (
        <div key={skill} className='skill-item'>
          {skill}
        </div>
      )
    })

    return (
      <div className='section'>
        <h1 className='heading'>Skills</h1>
        <h4 className='sub-heading'>Languages & Frameworks</h4>
        <div className='skill-list'>
          {langs}  
        </div>
        <h4 className='sub-heading'>Systems & Databases</h4>
        <div className='skill-list'>
          {systems}  
        </div>
        <h4 className='sub-heading'>General Skills</h4>
        <div className='skill-list'>
          {others}  
        </div>
        
      </div>
    )
  }
}